export function verifyEmailFormat(email: string): boolean {
  if (email.length > 320) {
    return false;
  }

  const emailRegex = /^[A-Za-z0-9._%+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}$/i;
  return emailRegex.test(email);
}
